import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteChildrenProps, RouteComponentProps } from 'react-router-dom';

import UserType from '../enum/UserType';
import User from '../model/User';
import { RootState } from '../reducer';

interface PrivateRouteProps {
    userType?: UserType | UserType[];
    component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
    render?: (props: RouteComponentProps<any>) => React.ReactNode;
    children?: ((props: RouteChildrenProps<any>) => React.ReactNode) | React.ReactNode;
    path?: string | readonly string[];
    exact?: boolean;
}

export function userSelector(state: RootState) {
    const { user } = state.authentication;
    return user;
}

export function checkUserRole(user: User, userType?: UserType | UserType[]): boolean {
    if (!userType) return true;

    if (Array.isArray(userType)) {
        return userType.findIndex(r => r === user.type) >= 0;
    } else {
        return userType === user.type;
    }
}

export function Unauthorized({redirectUrl = true}: {redirectUrl?: boolean}): JSX.Element {
    const queryString = window.location.hash;
    var Buffer = require('buffer/').Buffer;
    return <Redirect to={!!redirectUrl ? `/?r=${Buffer.from(queryString).toString('base64')}` : '/'} />;
}

export default function PrivateRoute(props: PrivateRouteProps): JSX.Element {
    const { userType, ...routeProps } = props;
    const user = useSelector(userSelector);

    if (!user) return <Unauthorized />;

    if (checkUserRole(user, userType) === false) return <Unauthorized redirectUrl={false} />;

    return <Route<any> {...routeProps} />;
}